import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/intematics-logo.png';

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
    setActiveDropdown(null);
    setMobileMenuOpen(false);
  
    // Scroll to top after navigation
    window.scrollTo(0, 0);
  };

  // Check if screen is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const handleMouseEnter = (dropdown) => {
    if (!isMobile) {
      setActiveDropdown(dropdown);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setActiveDropdown(null);
    }
  };
  
  
    

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    if (isMobile) {
      setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    }
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <div className="logo" onClick={() => handleNavigate('/')} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Intematics" />
        </div>

        {/* Hamburger menu button - only visible on mobile */}
        <div className="hamburger-menu" onClick={toggleMobileMenu}>
          <div className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Nav links - hidden on mobile unless menu is open */}
        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <div 
            className={`dropdown ${activeDropdown === 'products' ? 'active' : ''}`}
            onMouseEnter={() => handleMouseEnter('products')}
            onMouseLeave={handleMouseLeave}
            onClick={() => toggleDropdown('products')}
          >
            <span>Products</span>
            <div className="dropdown-arrow"></div>
            {activeDropdown === 'products' && (
              <div className="dropdown-menu">
                <ul>
                  <li>
                    <span className="bullet">•</span>
                    <span 
                      className="nav-link" 
                      onClick={() => handleNavigate('/thinkfinance')}
                    >
                      ThinkFinance
                    </span>
                  </li>
                  <li>
                    <span className="bullet">•</span>
                    <span 
                      className="nav-link" 
                      onClick={() => handleNavigate('/thinkhr')}
                    >
                      ThinkHR
                    </span>
                  </li>
                  <li>
                    <span className="bullet">•</span>
                    <span 
                      className="nav-link" 
                      onClick={() => handleNavigate('/marketresearch')}
                    >
                      Market Research
                    </span>
                  </li>
                </ul>
              </div>
            )}
          </div>
          
          <div 
            className={`dropdown ${activeDropdown === 'solutions' ? 'active' : ''}`}
            onMouseEnter={() => handleMouseEnter('solutions')}
            onMouseLeave={handleMouseLeave}
            onClick={() => toggleDropdown('solutions')}
          >
            <span>Solutions</span>
            <div className="dropdown-arrow"></div>
            {activeDropdown === 'solutions' && (
              <div className="dropdown-menu">
                <ul>
                  <li>
                    <span className="bullet">•</span>
                    <span
                      className="nav-link" 
                      onClick={() => handleNavigate('/BSC')}
                >
                      Balanced Scorecard
                </span>
                  </li>
                  <li>
                    <span className="bullet">•</span>
                    <span
                      className="nav-link" 
                      onClick={() => handleNavigate('/DAAS')}
                      >
                      Data Analytics and Solutions
                      </span>
                  </li >
                </ul>   
  </div >
)}    
          </div>
          <div
            className={`dropdown ${activeDropdown === 'resources' ? 'active' : ''}`}
            onMouseEnter={() => handleMouseEnter('resources')}
            onMouseLeave={handleMouseLeave}
            onClick={() => toggleDropdown('resources')}
          >
            <span>Resources</span>
            <div className="dropdown-arrow"></div>
            {activeDropdown === 'resources' && (
              <div className="dropdown-menu">
                <ul>
                  <li>
                    <span className="bullet">•</span>
                    <span 
                      className="nav-link" 
                      onClick={() => handleNavigate('/usecase_finance')}
                    >
                      ThinkFinance Use Case
                    </span>
                  </li>
                  <li>
                    <span className="bullet">•</span>
                    <span 
                      className="nav-link" 
                      onClick={() => handleNavigate('/usecase_hr')}
                    >
                      ThinkHR Use Case
                    </span>
                  </li>
                </ul>
              </div>
            )}
          </div>
          
          <div 
            className={`dropdown ${activeDropdown === 'why' ? 'active' : ''}`}
            onMouseEnter={() => handleMouseEnter('why')}
            onMouseLeave={handleMouseLeave}
            onClick={() => toggleDropdown('why')}
          >
            <span>Why Intematics</span>
            <div className="dropdown-arrow"></div>
            {activeDropdown === 'why' && (
              <div className="dropdown-menu">
                <ul>
                  <li>
                    <span className="bullet">•</span>
                    <span 
                      className="nav-link" 
                      onClick={() => handleNavigate('/testimonials')}
                    >
                      Testimonials
                    </span>
                  </li>
                   <li>
                    <span className="bullet">•</span>
                    <span
                      className="nav-link" 
                      onClick={() => handleNavigate('/ContactUs')}
                      >
                      Contact Us
                      </span>
                  </li >
                </ul>
              </div>
            )}
</div>
          
          <button className="login-button mobile-login" onClick={() => window.open('https://thinkai.intematics.com/app/', '_blank')}>Login</button>

        </div>
        
        <button className="login-button desktop-login" onClick={() => window.open('https://thinkai.intematics.com/app/', '_blank')}>Login</button>
      </div>
    </nav>
  );
};

export default Navbar;